module.exports = __webpack_public_path__ + "img/spelning1.ec6a3115.jpg";